import { render, staticRenderFns } from "./PreviewColumn.vue?vue&type=template&id=6fbe2258&scoped=true&"
import script from "./PreviewColumn.vue?vue&type=script&lang=js&"
export * from "./PreviewColumn.vue?vue&type=script&lang=js&"
import style0 from "./PreviewColumn.vue?vue&type=style&index=0&id=6fbe2258&prod&lang=scss&"
import style1 from "./PreviewColumn.vue?vue&type=style&index=1&id=6fbe2258&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fbe2258",
  null
  
)

export default component.exports